import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import commonReducer from './common/reducer';
import contentReducer from './content/reducer';
import homeReducer from './home/reducer';
import projectReducer from './project/reducer';
import searchReducer from './search/reducer';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';

const combinedReducer = combineReducers({
  common: commonReducer,
  home: homeReducer,
  search: searchReducer,
  project: projectReducer,
  content: contentReducer,
});
type Action = {
  type: string;
  payload?: unknown;
};
type RootState = ReturnType<typeof combinedReducer>;

const reducer = (state: RootState, action: Action) => {
  switch (action.type) {
    case HYDRATE: {
      const payload = action.payload as object;
      // Attention! This will overwrite client state! Real apps should use proper reconciliation.
      return { ...state, ...payload };
    }
    default:
      return combinedReducer(state, action);
  }
};

const makeStore = () => {
  return createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
};

export const wrapper = createWrapper(makeStore, { debug: false });
